import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const NavbarAdmin = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const userName = localStorage.getItem('userName');

  const handleLogout = () => {
    localStorage.clear();
    navigate('/loginusuario');
  };

  return (
    <nav className="bg-neutral-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <img
              src={`${process.env.PUBLIC_URL}/lgo-udi-blanco.png`}
              alt="Logo UDI"
              className="h-8 w-auto"/>
              <span className="font-semibold text-xl">
              Revisión de Matrícula
              </span>
          </div>

          {/* Hamburger button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-neutral-800"
            >
              <svg
                className={`h-6 w-6 ${isOpen ? 'hidden' : 'block'}`}
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <svg
                className={`h-6 w-6 ${isOpen ? 'block' : 'hidden'}`}
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            <Link
              to="/dashboard-admin"
              className="px-3 py-2 rounded-md text-sm font-medium hover:bg-neutral-800"
            >
              Dashboard
            </Link>
            <Link
              to="/gestion-usuarios"
              className="px-3 py-2 rounded-md text-sm font-medium hover:bg-neutral-800"
            >
              Gestión de Usuarios
            </Link>
          </div>

          <div className="hidden md:flex md:items-center">
            <span className="text-sm mr-4">Bienvenido, {userName}</span>
            <button
              onClick={handleLogout}
              className="bg-white hover:bg-neutral-200 text-neutral-950 px-4 py-2 rounded-md text-sm transition duration-300"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`${isOpen ? 'block' : 'hidden'} md:hidden`}>
        <div className="px-2 pt-2 pb-3 space-y-1">
          <Link
            to="/dashboard-admin"
            className="block px-3 py-2 rounded-md text-base font-medium hover:bg-neutral-800"
            onClick={() => setIsOpen(false)}
          >
            Dashboard
          </Link>
          <Link
            to="/gestion-usuarios"
            className="block px-3 py-2 rounded-md text-base font-medium hover:bg-neutral-800"
            onClick={() => setIsOpen(false)}
          >
            Gestión de Usuarios
          </Link>
          <div className="pt-4 pb-3 border-t border-neutral-700">
            <div className="px-3">
              <span className="text-sm">Bienvenido, {userName}</span>
            </div>
            <div className="mt-3 px-3">
              <button
                onClick={handleLogout}
                className="block w-full px-3 py-2 rounded-md text-base font-medium bg-red-600 hover:bg-red-700"
              >
                Cerrar Sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavbarAdmin;